import * as React from 'react';

import { CommonStyles } from '~common/react/CommonStyles';
import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { IPublishedConnectionTaskInfo } from '~src/ts/models/IPublishedConnectionTaskInfo';

const cssPrefix = 'PublishedConnectionTaskRefreshTypeDropdown';

const noTaskClass = cssClass(cssPrefix, 'noTask', {
  padding: CommonStyles.Sizes.LargeSpace,
});

export const PublishedConnectionScheduledTasksGrid: React.FC<{
  tasks: ReadonlyArray<IPublishedConnectionTaskInfo>;
}> = ({ tasks }) => {
  if (tasks.length === 0) {
    return (
      <div className={noTaskClass}>{Messages.publishedConnectionNoScheduledTasksMessage()}</div>
    );
  }

  //  There are tasks, show grid.
  return (
    <></>
  );
};
PublishedConnectionScheduledTasksGrid.displayName = 'PublishedConnectionScheduledTasksGrid';
